import styled from 'styled-components';

export const Wrapper = styled.label`
  display: block;
  position: relative; 
  cursor: pointer;
  font-size: 13px;
  user-select: none;
  width: ${({ width }) => width};
  min-height: ${({ size }) => `${size}px`};
  padding-left: ${({ size }) => `calc(${size}px + 4px)`};
  display: flex;
  align-items: center;
  line-height: 1.5;
`;
